/**
 * upgradeStore — gateway global do fluxo "fazer upgrade".
 *
 * Logado nunca deve ser jogado pra `/pricing` (página pública). Em vez
 * disso, qualquer call-site que precise oferecer upgrade chama
 * `openUpgrade()` → AuthRoot mostra um <PlanPickerDialog> compartilhado
 * → escolha vira <BillingCheckoutDialog>. Single flow.
 *
 * Lugares que consomem:
 *   - PlanLock (feature locks no editor)
 *   - Analytics + AnalyticsOverview (CTA "ver gráficos avançados")
 *   - Editor toolbar (CTA dentro do RadialMenu / hotspot pago)
 *   - QuotaExceededDialog (storage cheia)
 *   - Sidebar / BillingQuickPanel (padrão antigo, mantém compat)
 *
 * Por que NÃO useNavigate('/pricing'): a página `/pricing` é
 * exclusivamente marketing pra prospect — chegar lá logado polui o
 * funil (já é cliente, não precisa de pitch). Picker dialog dá foco
 * na DECISÃO sem perder contexto da tela atual.
 */
import { create } from 'zustand';

interface UpgradeState {
  /** True quando o picker dialog está aberto */
  open: boolean;
  /** Optional source label pra analytics futuras (ex: 'editor-lock', 'analytics-cta') */
  source: string | null;
  /** Abre o picker (mostra os planos não-atuais ordenados por preço) */
  openUpgrade: (source?: string) => void;
  /** Fecha o picker */
  closeUpgrade: () => void;
}

export const useUpgradeStore = create<UpgradeState>((set) => ({
  open: false,
  source: null,
  openUpgrade: (source) => set({ open: true, source: source ?? null }),
  closeUpgrade: () => set({ open: false }),
}));
